export default "__VITE_ASSET__xKefacpB__"